import React from 'react';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { Note } from '../../../store/slices/teamFocusSession/types';

import EmptyState from '../../ui/empty-state';

interface NotesTabProps {
    notes?: Note[];
    currentUserId?: string;
    onDeleteNote: (noteId: string) => void;
    onEditNote?: (note: Note) => void;
}

const NotesTab: React.FC<NotesTabProps> = ({
    notes = [],
    currentUserId = '',
    onDeleteNote,
    onEditNote,
}) => {
    // defensive: sometimes upstream might pass null/object; coerce to array
    const safeNotes: Note[] = Array.isArray(notes) ? notes : [];

    return (
        <div>
            <div className="space-y-3">
                {safeNotes.map(note => (
                    <div key={note.id} className="p-4 border rounded-xl hover:border-orange-200/60 flex justify-between group">
                        <div className="flex-1">
                            <p
                                className="text-gray-900 text-sm cursor-pointer"
                                onClick={() => onEditNote?.(note)}
                            >
                                {note.note}
                            </p>
                            <div className="flex items-center gap-2 mt-1">
                                {note.creator && (
                                    <p className="text-gray-500 text-xs">
                                        by {note.creator.name}
                                    </p>
                                )}
                                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${note.is_public
                                    ? 'bg-green-100 text-green-700'
                                    : 'bg-gray-100 text-gray-600'
                                    }`}>
                                    {note.is_public ? 'Public' : 'Private'}
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            {note.created_by === currentUserId && (
                                <button onClick={() => onDeleteNote(note.id)} className="text-gray-400 hover:text-red-500">
                                    <RiDeleteBin4Fill />
                                </button>
                            )}
                        </div>
                    </div>
                ))}
                {safeNotes.length === 0 && (
                    <EmptyState
                        icon="📓"
                        title="No notes yet"
                        description="Use the button below to add your first note."
                    />
                )}
            </div>
        </div>
    );
};

export default NotesTab;
